import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import '../styles/Header.css';
import logo from '../assets/images/Umrah_Logo.png';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const navigate = useNavigate();
  const menuRef = useRef(null);
  const hamburgerRef = useRef(null);

  const handleMenuToggle = () => setIsMenuOpen(prev => !prev);

  const handleNavigate = (path) => {
    navigate(path);
    setIsMenuOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      const clickedOutsideMenu =
        menuRef.current && !menuRef.current.contains(event.target);
      const clickedOutsideHamburger =
        hamburgerRef.current && !hamburgerRef.current.contains(event.target);

      if (clickedOutsideMenu && clickedOutsideHamburger) {
        setIsMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <nav className="nav">
      <div className="logo-container" onClick={() => handleNavigate('/')}>
        <img src={logo} alt="Umrah Packages Logo" className="logo" />
        <div className="brand-text">
          <h1>Umrah Bröderna</h1>
          <span>Ya Ra AB</span>
        </div>
      </div>

      <div
        className={`hamburger ${isMenuOpen ? 'active' : ''}`}
        onClick={handleMenuToggle}
        ref={hamburgerRef}
      >
        <div></div>
        <div></div>
        <div></div>
      </div>

      <ul className={`menu ${isMenuOpen ? 'show' : ''}`} ref={menuRef}>
        <li><Link to="/" onClick={() => handleNavigate('/')}>Hem</Link></li>
        <li><Link to="/umrah-package" onClick={() => handleNavigate('/umrah-package')}>Våra Paket</Link></li>
        <li><Link to="/about-umrah" onClick={() => handleNavigate('/about-umrah')}>Om Umrah</Link></li>
        <li><Link to="/FAQ" onClick={() => handleNavigate('/FAQ')}>Frågor & Svar</Link></li>
        <li><Link to="/intresseanmalan" onClick={() => handleNavigate('/intresseanmalan')}>Intresseanmälan</Link></li>
      </ul>
    </nav>
  );
};

export default Header;
